/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const IAPCLONEREASON = {
    Cloneforoverride: '1',
    Cloneforupdate: '2'
} as const;
export type IAPCLONEREASON = typeof IAPCLONEREASON[keyof typeof IAPCLONEREASON];


export function IAPCLONEREASONFromJSON(json: any): IAPCLONEREASON {
    return IAPCLONEREASONFromJSONTyped(json, false);
}

export function IAPCLONEREASONFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAPCLONEREASON {
    return json as IAPCLONEREASON;
}

export function IAPCLONEREASONToJSON(value?: IAPCLONEREASON | null): any {
    return value as any;
}

